export default {
   xs: 576,
   sm: 800,
   md: 992,
   navigation: 1080,
   lg: 1200,
   xl: 1600,
   xxl: Infinity,
};
